<template>
  <div>
    <div class="main">
      <div class="breadcrumb">
        <span class="crumb" @click="$router.push({path: '/'})">首页</span>
        <span>></span>
        <span>关注</span>
        <span>></span>
        <span>{{title}}</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="top-nav">
            <ul>
              <li
                v-for="(item,i) in navList"
                :key="i"
                :class="i==isActive?'actives':''"
                @click="change(i,item.title)"
              >{{item.title}}</li>
            </ul>
          </div>
          <div class="info">
            <ul class="author" v-if="isActive==2">
              <li v-for="(item,i) in authorList" :key="i">
                <div class="author-box">
                  <div class="img" @click="authorDetail(item)">
                    <img :src="item.avatar" alt />
                  </div>
                  <div class="author-mess">
                    <div>
                      <p>{{item.name}}</p>
                      <div>
                        <span>{{item.articles_count}}篇文章</span>
                        <span>{{item.followers_count}}人关注</span>
                      </div>
                    </div>
                    <el-button
                      :class="item.follow=='undefined'?'':'isActice'"
                      v-if="item.follow"
                      @click="cancelAttention(item)"
                    >已关注</el-button>
                  </div>
                </div>
              </li>
            </ul>
            <ul class="laber" v-else-if="isActive==1">
              <li v-for="(item,i) in info" :key="i">
                <p @click="laberDetail(item,magazine)">#{{item.name}}</p>
                <div>
                  <span>{{item.articles_count}}篇文章</span>
                  <span>{{item.followers_count}}人关注</span>
                </div>
                <el-button
                  :class="item.follow=='undefined'?'':'isActice'"
                  v-if="item.follow"
                  @click="cancelColumn(item)"
                >已关注</el-button>
              </li>
            </ul>
            <ul class="laber" v-else-if="isActive==0">
              <li v-for="(item,i) in laberList" :key="i">
                <p @click="laberDetail(item)">#{{item.name}}</p>
                <div>
                  <span>{{item.articles_count}}篇文章</span>
                  <span>{{item.followers_count}}人关注</span>
                </div>
                <el-button
                  :class="item.follow=='undefined'?'':'isActice'"
                  v-if="item.follow"
                  @click="cancelLaber(item)"
                >已关注</el-button>
              </li>
            </ul>
              <p class="loadMore" @click="loadMore" v-if="showMore">加载更多
              <p style="text-align:center;margin-top:4px;" v-if="showMore">
                <img src="@/assets/img/more.png" alt />
              </p></p>
          </div>
        </div>
        <div class="content-r">
          <DropDownMenu></DropDownMenu>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DropDownMenu from "@/components/dropDownMenu";
import { getConcernsList } from "@/api/collect";
import {
  getCancelAttention,
  getCancelLaber,
  getCancelColumn
} from "@/api/public";
import { userInformation } from "@/utils/userInfo";
import { getTdkList} from "@/api/tdk";

export default {
  components: {
    DropDownMenu
  },
  data() {
    return {
      isActive: 0,
      title: "标签",
      navList: [{ title: "标签" }, { title: "杂志栏目" }, { title: "作者" }],
      info: [],
      authorList: [],
      laberList: [],
      params: {
        page: 1,
        per: 5,
        follow_type: "topic"
      },
      id: "",
      magazine: "magazine",
      showMore: false
    };
  },
  methods: {
    change(flag, title) {
      this.isActive = flag;
      this.title = title;
      this.params.page = 1;
      if (this.isActive == 0) {
        this.params.follow_type = "topic";
        getConcernsList(this.params, this.id).then(res => {
          this.laberList = res.data.data;
           if(res.data.meta.current_page >=res.data.meta.total_pages){
        this.showMore = false
      }else {
        this.showMore = true
      }
        });
      } else if (this.isActive == 1) {
        this.params.follow_type = "column";
        getConcernsList(this.params, this.id).then(res => {
          this.info = res.data.data;
           if(res.data.meta.current_page >=res.data.meta.total_pages){
        this.showMore = false
      }else {
        this.showMore = true
      }
        });
      } else if (this.isActive == 2) {
        this.params.follow_type = "author";
        getConcernsList(this.params, this.id).then(res => {
          this.authorList = res.data.data;
           if(res.data.meta.current_page >=res.data.meta.total_pages){
        this.showMore = false
      }else {
        this.showMore = true
      }
        });
      }
    },
    // 加载更多
    loadMore(){
      this.params.page++
      if (this.isActive == 0) {
        this.params.follow_type = "topic";
        getConcernsList(this.params, this.id).then(res => {
           for(var i in res.data.data) {
            this.laberList.push(res.data.data[i])
          }
           if(res.data.meta.current_page >=res.data.meta.total_pages){
        this.showMore = false
      }else {
        this.showMore = true
      }
        });
      } else if (this.isActive == 1) {
        this.params.follow_type = "column";
        getConcernsList(this.params, this.id).then(res => {
           for(var i in res.data.data) {
            this.info.push(res.data.data[i])
          }
           if(res.data.meta.current_page >=res.data.meta.total_pages){
        this.showMore = false
      }else {
        this.showMore = true
      }
        });
      } else if (this.isActive == 2) {
        this.params.follow_type = "author";
        getConcernsList(this.params, this.id).then(res => {
          for(var i in res.data.data) {
            this.authorList.push(res.data.data[i])
          }
           if(res.data.meta.current_page >=res.data.meta.total_pages){
        this.showMore = false
      }else {
        this.showMore = true
      }
        });
      }
      this.resetSetItem('getFixeds',true)
    },
    // 取消关注(作者)
    cancelAttention(item) {
      getCancelAttention(item.id).then(res => {
        this.params.follow_type = "author";
        getConcernsList(this.params, this.id).then(res => {
          this.authorList = res.data.data;
        });
      });
    },
    // 取消关注(杂志)
    cancelColumn(item) {
      getCancelColumn(item.id).then(res => {
        this.params.follow_type = "column";
        getConcernsList(this.params, this.id).then(res => {
          this.info = res.data.data;
        });
      });
    },
    // 取消关注（标签）
    cancelLaber(item) {
      getCancelLaber(item.id).then(res => {
        this.params.follow_type = "topic";
        getConcernsList(this.params, this.id).then(res => {
          this.laberList = res.data.data;
        });
      });
    },
    // 作者列表页
    authorDetail(scope) {
      this.$router.push({
        name: "author_detail",
        params: { id: scope.id }
      });
    },
    // 标签列表页
    laberDetail(scope, type) {
      this.resetSetItem("isActive", 0);
      this.$router.push({
        name: "hot_laber",
        params: {
          id: scope.id,
          type: type,
          isSearch: false
        }
      });
    }
  },
  created() {
   
    getTdkList({column:0}).then(res => {
      console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title= res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })
  
    if (localStorage.getItem("Authorization")) {
      var userInfo = {};
      userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.id = userInfo.id;
    }
    getConcernsList(this.params, this.id).then(res => {
      this.laberList = res.data.data;
      if(res.data.meta.current_page >=res.data.meta.total_pages){
        this.showMore = false
      }else {
        this.showMore = true
      }
    });
  }
};
</script>
<style lang="scss" scoped>
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  .crumb {
    cursor: pointer;
  }
  span:last-child {
    color: #0091ff;
  }
}
.top-nav {
  display: flex;
  background: #ffffff;
  justify-content: space-between;
  line-height: 50px;
  align-items: center;
  padding: 0 30px;
  ul {
    display: flex;
    li {
      font-size: 16px;
      margin-right: 50px;
      color: #999999;
      cursor: pointer;
    }
    .actives {
      color: #0091ff;
      border-bottom: 4px solid;
    }
  }
  .el-button {
    border-radius: 15px;
    background: #0091ff;
    color: #ffffff;
    height: 30px;
    width: 80px;
    padding: 0;
    cursor: pointer;
  }
}
.info {
  margin-top: 30px;
  min-height: 800px;
  .laber {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    li {
      background: #ffffff;
      padding: 30px;
      width: 25%;
      color: #0091ff;
      margin-bottom: 30px;
      p {
        font-size: 18px;
        line-height: 34px;
        cursor: pointer;
      }
      div {
        font-size: 14px;
        color: #999999;
        margin-bottom: 22px;
        span {
          margin-right: 6px;
          display: inline-block;
        }
      }
      .el-button {
        border-radius: 15px;
        width: 80px;
        height: 30px;
        padding: 0;
        color: #0091ff;
        border: 1px solid;
      }
      .el-button:focus,
      .el-button:hover {
        background-color: #ffffff;
      }
    }
  }
  .laber:after {
    content: "";
    width: 31%;
  }
  .author {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    li {
      background: #ffffff;
      padding: 30px;
      width: 42%;
      margin-bottom: 30px;
      .author-box {
        display: flex;
        align-items: center;
        .img {
          width: 25%;
          max-width: 60px;
          margin-right: 10px;
          cursor: pointer;
          img {
            width: 100%;
            object-fit: cover;
            border-radius: 50%;
          }
        }
        .author-mess {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 18px;
          div {
            p {
              line-height: 30px;
            }
            div {
              font-size: 14px;
              color: #999999;
            }
          }
          .el-button {
            border-radius: 15px;
            width: 80px;
            height: 30px;
            padding: 0;
            color: #0091ff;
            border: 1px solid;
          }
          .el-button:focus,
          .el-button:hover {
            background-color: #ffffff;
          }
        }
      }
    }
  }
  .author:after {
    content: "";
    width: 42%;
  }
  .loadMore{
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    cursor:pointer;
    padding-bottom: 30px;
  }
}
.isActice {
  background: #fff;
  color: #0091ff;
  border: 1px solid;
}
</style>



// WEBPACK FOOTER //
// src/views/myConcerns/index.vue